export const FETCH_SCHOOLS_REQUEST = 'FETCH_SCHOOLS_REQUEST';
export const FETCH_SCHOOLS_SUCCESS = 'FETCH_SCHOOLS_SUCCESS';
export const FETCH_SCHOOLS_FAILURE = 'FETCH_SCHOOLS_FAILURE';
export const RESET_SCHOOLS_FAILURE = 'RESET_SCHOOLS_FAILURE';

export const fetchSchoolsRequest = () => ({ type: FETCH_SCHOOLS_REQUEST });

export const fetchSchoolsSuccess = payload => ({
  type: FETCH_SCHOOLS_SUCCESS,
  payload,
});

export const fetchSchoolsFailure = error => ({
  type: FETCH_SCHOOLS_FAILURE,
  payload: error,
});

export const resetSchoolsFailure = () => ({ type: RESET_SCHOOLS_FAILURE });
